import HandleService from "./handleService";

const api = HandleService();

export { AdminAuthService } from "./api/admin-auth";

export default api;
